'use client'

import Cookies from 'js-cookie'

import { Logger } from '@rewardops/utils'

const PRESERVED_COOKIES = [
  // related to law 25 banner
  'OptanonConsent',
  'OptanonAlertBoxClosed',
  // add any other here and mention their purpose please
]

interface SignOutOptions {
  redirect?: boolean
  redirectUrl?: string
  logoutEndpoint?: string | null
}

export async function signOut({
  redirect = true,
  redirectUrl = '/',
  logoutEndpoint = null,
}: SignOutOptions = {}) {
  if (logoutEndpoint) {
    try {
      await fetch(logoutEndpoint, {
        method: 'POST',
        headers: {
          'Accept-API-Version': 'resource=3.1, protocol=1.0',
        },
        credentials: 'include',
      }).then((res) => res.json())
    } catch (err) {
      Logger.info('sso logout failed')
      Logger.error(err)
    }
  }

  // Clear local storage
  window.localStorage.clear()
  window.sessionStorage.clear()

  // Clear all cookies except for ones we want to preserve
  const cookies = Cookies.get()
  for (const cookie in cookies) {
    if (!PRESERVED_COOKIES.includes(cookie)) {
      Cookies.remove(cookie)
    }
  }

  let logoutRedirectUrl: string | undefined
  try {
    const res = await fetch('/api/auth/session', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      // Pass the post-logout destination so the server can build an
      // RP-initiated logout URL when the provider has an end-session endpoint.
      body: JSON.stringify({ redirectUrl }),
    })
    const data = await res.json()
    logoutRedirectUrl = data?.logoutRedirectUrl
  } catch (err) {
    Logger.info('session delete failed')
    Logger.error(err)
  }

  if (redirect) {
    // Prefer the IdP end-session URL (which itself redirects back to
    // redirectUrl); fall back to a local redirect when it isn't configured.
    window.location.href = logoutRedirectUrl ?? redirectUrl
  }
}
